export const namespaced = true
export const state = {
  departments: [
    "Creative",
    "PrePress",
    "Data Processing",
    "Print",
    "Outside Sales",
    "LF Finish",
    "Bindery",
    "Letter Shop"
  ]
}

export const actions = {}

export const getters = {
  getDepartments: state => {
    //console.log(state)
    return state.departments
  }
}
